import React, { useEffect, useRef, useCallback } from 'react';

import style from './main.module.scss';
import Messages from '../Messages';
import SendMessage from '../SendMessage';
import useApp from 'hooks/useApp';
import UploadFile from 'views/UploadFile';
import Initialising from 'views/Initialising';
import Error from 'views/Error';
import Disconnected from 'views/Disconnected';
import EndChatDialog from 'components/EndChatDialog';
import { closeIframe, postMessageToParent } from 'utils';
import useInitialiseApp from 'hooks/useInitialiseApp';
import AutoTranslateDialog from 'components/AutoTranslateDialog';
import useScreenReaderLanguage from 'hooks/useScreenReaderLanguage';

interface Props { }

const Main: React.FC<Props> = () => {
    const { mode, initialised, error, lostConnection, endChatConfirm, autoTranslateConfirm } = useApp();
    const chatContainer = useRef<HTMLDivElement>(null);

    useInitialiseApp(true);
    useScreenReaderLanguage();

    const handleKeyEventCallback = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                closeIframe();
            }
        },
        []
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEventCallback)
        return () => {
            document.removeEventListener('keydown', handleKeyEventCallback)
        }
    }, [handleKeyEventCallback]);

    useEffect(() => {
        const handle = function () {
            postMessageToParent('user-chat-focus', {});
        }

        window.addEventListener('focus', handle);

        return () => {
            window.removeEventListener('focus', handle)
        }
    }, [])

    if (lostConnection) return <Disconnected />
    if (error) return <Error />
    if (!initialised) return <Initialising />

    return (
        <div ref={chatContainer} className={style.container}>
            <EndChatDialog endChatConfirm={!!endChatConfirm} />

            {autoTranslateConfirm && (
                <AutoTranslateDialog />
            )}

            <Messages />

            {mode === "FILE_UPLOAD" ? <UploadFile /> : <SendMessage />}
        </div>
    );
};

export default Main;
